import { createFileRoute, redirect } from "@tanstack/solid-router";
import { parseTireSearch } from "~/lib/tire-search";

// The tire curves page moved under /tuning. Links posted to the community
// point here, so the old path stays alive as a redirect and carries the view
// state along. The server answers a direct hit with a 301; this covers the
// in-app and service-worker cases, where the request never reaches it.
export const Route = createFileRoute("/tires")({
  validateSearch: parseTireSearch,
  beforeLoad: ({ search }) => {
    throw redirect({ to: "/tuning/tires", search, replace: true });
  },
});
